"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Flag = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./flag.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Flag = _ref => {
  let {
    direction,
    flag,
    label,
    customCssClass
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "flag flag-".concat(flag, " ").concat(direction, " ").concat(customCssClass),
    role: "presentation",
    tabIndex: -1,
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("em", null, label || flag));
};
exports.Flag = Flag;
Flag.propTypes = {
  flag: _propTypes.default.string,
  label: _propTypes.default.string,
  direction: _propTypes.default.string,
  customCssClass: _propTypes.default.string
};
Flag.defaultProps = {
  customCssClass: '',
  direction: '',
  flag: 'info',
  label: 'info'
};
var _default = exports.default = Flag;